<template>
  <div class="search-box" :style="styleObj">
    <el-input clearable v-model="inpVal" size="small"
              :placeholder="placeholder"
              @keyup.native.enter="goSearch"
              @change="inpChange">
      <el-button slot="append" icon="el-icon-search" @click="goSearch"></el-button>
    </el-input>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        inpVal: ''
      }
    },
    props: {
      width: {
        type: String,
        default: '400px'
      },
      placeholder: {
        type: String,
        default: '请输入关键字搜索',
      },
      value: [String, Number],
    },
    methods: {
      goSearch () {
        this.$emit('search', this.inpVal)
      },
      inpChange (v) {
        this.$emit('input', v)
      }
    },
    computed: {
      styleObj () {
        return {width: this.width}
      }
    },
    mounted () {
    },
    watch: {
      value (v) {
        if (v == '') {
          this.inpVal = ''
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Search/index.vue